import { FetchClient } from '@fgrzl/fetch';
import { addAuthorization } from '@fgrzl/fetch/middleware/authorization';
import { addRateLimit } from '@fgrzl/fetch/middleware/rate-limit';
import { addRetry } from '@fgrzl/fetch/middleware/retry';

import { createAdapter as createapiv1Adapter } from './apiv1.g';
import { createAdapter as createAuthAdapter } from './auth.g';
import { createAdapter as createcatalogv1Adapter } from './catalogv1.g';

function redirectToLoginWithReturnUrl(): void {
  const returnUrl = encodeURIComponent(
    `${window.location.pathname}${window.location.search}`
  );
  window.location.assign(`/login?return_url=${returnUrl}`);
}

const client = new FetchClient({
  credentials: 'same-origin',
});

addRetry(client, {
  maxRetries: 2,
  delay: 1000,
});

addRateLimit(client, {
  maxRequests: 100,
  windowMs: 60 * 1000,
});

addAuthorization(client, {
  onUnauthorized: redirectToLoginWithReturnUrl,
  statusCodes: [401],
  skipPatterns: ['/auth', '/login'],
});

export const apiv1 = createapiv1Adapter(client);
export const catalogv1 = createcatalogv1Adapter(client);
export const auth = createAuthAdapter(client);
